import { getDocumentDefinitions } from '../../../helpers/graphqlParseHelpers';

export function generateOperationDisplayName(operation: string) {
  return (
    getDocumentDefinitions(operation, {
      mutation: null,
      query: null,
      subscription: null,
    }).operationDefinitions[0]?.name ?? undefined
  );
}
